import { Stack } from "@mantine/core";
import { UserActivityChart } from "../../../components/charts/UserActivityChart";

const UserAnalyticsPage = () => {
    return (
        <Stack gap="md">
            <UserActivityChart
                title="Most Active Users"
                height={400}
                showTitle={true}
                showLegend={true}
                showStats={true}
                defaultTopUsers={15}
                colors={{
                    total: "#339af0"
                }}
            />
        </Stack>
    );
};

export default UserAnalyticsPage;
